import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Small delay before showing banner
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    const allAccepted = { necessary: true, analytics: true, marketing: true };
    localStorage.setItem('cookieConsent', JSON.stringify(allAccepted));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  const acceptSelected = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  const rejectAll = () => {
    const onlyNecessary = { necessary: true, analytics: false, marketing: false };
    localStorage.setItem('cookieConsent', JSON.stringify(onlyNecessary));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent">
        <div className="cookie-consent-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Cookie size={20} style={{ color: 'var(--copper)' }} />
            <h3 style={{ fontSize: '1rem', fontWeight: 600, margin: 0 }}>
              Politica de Cookie-uri
            </h3>
          </div>
          <button
            onClick={rejectAll}
            className="cookie-close-btn"
            aria-label="Închide"
          >
            <X size={18} />
          </button>
        </div>

        <div className="cookie-consent-body">
          <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', lineHeight: 1.6, margin: '0 0 1rem 0' }}>
            Folosim cookie-uri pentru a îmbunătăți experiența ta pe site. Cookie-urile necesare sunt esențiale
            pentru funcționarea site-ului. Poți alege să accepți și cookie-urile opționale pentru analiză și marketing.
          </p>

          {showPreferences && (
            <div className="cookie-preferences">
              <label className="cookie-option">
                <input
                  type="checkbox"
                  checked={preferences.necessary}
                  disabled
                  className="cookie-checkbox"
                />
                <div>
                  <span className="cookie-option-title">Necesare</span>
                  <span className="cookie-option-desc">Esențiale pentru funcționarea site-ului</span>
                </div>
              </label>

              <label className="cookie-option">
                <input
                  type="checkbox"
                  checked={preferences.analytics}
                  onChange={(e) => setPreferences(p => ({ ...p, analytics: e.target.checked }))}
                  className="cookie-checkbox"
                />
                <div>
                  <span className="cookie-option-title">Analitice</span>
                  <span className="cookie-option-desc">Ne ajută să înțelegem cum folosești site-ul</span>
                </div>
              </label>

              <label className="cookie-option">
                <input
                  type="checkbox"
                  checked={preferences.marketing}
                  onChange={(e) => setPreferences(p => ({ ...p, marketing: e.target.checked }))}
                  className="cookie-checkbox"
                />
                <div>
                  <span className="cookie-option-title">Marketing</span>
                  <span className="cookie-option-desc">Pentru a-ți oferi conținut relevant</span>
                </div>
              </label>
            </div>
          )}

          <div className="cookie-consent-actions">
            <button
              onClick={() => setShowPreferences(!showPreferences)}
              className="btn-cookie-secondary"
            >
              {showPreferences ? 'Ascunde opțiuni' : 'Personalizează'}
            </button>

            {showPreferences ? (
              <button onClick={acceptSelected} className="btn-cookie-primary">
                Salvează preferințele
              </button>
            ) : (
              <>
                <button onClick={rejectAll} className="btn-cookie-secondary">
                  Doar necesare
                </button>
                <button onClick={acceptAll} className="btn-cookie-primary">
                  Accept toate
                </button>
              </>
            )}
          </div>
        </div>

        <div className="cookie-consent-footer">
          <a href="#" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('openLegal', { detail: 'privacy' })); }}>
            Politica de Confidențialitate
          </a>
          <span>•</span>
          <a href="#" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('openLegal', { detail: 'cookies' })); }}>
            Politica de Cookie-uri
          </a>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
